<template>
  <div class="success" :style="'min-height:' + (fullHeight-100) + 'px;'">
    <!-- 头图 -->
    <div class="headImgs">
      <img src="../../assets/imgs/apply/market.png" />
    </div>
    <div class="productList">
      <div class="list" v-for="(item,index) in productList" :key="index">
        <div class="bankName">
          <div class="name">
            <img :src="baseUrl + item.proIcon" />
            <span>{{item.parentBankName}}{{item.name}}</span>
          </div>
        </div>
        <div class="details">
          <div class="type">
            <div style="border-right: 1px solid #d5d5d5;">
              <span>{{item.interestRateFloor}}-{{item.interestRateCap}}</span>年利率(%)
            </div>
            <div style="border-right: 1px solid #d5d5d5;">
              <span>{{item.loanLimitFloor}}-{{item.loanLimitCap}}</span>额度(万元)
            </div>
            <div style="position: relative;">
              <span>{{item.minLoanTime}}-{{item.maxLoanTime}}</span>
              <i style="font-style: initial;">贷款(月)</i>
              <i
                v-if="item.loanNum"
                style="font-size:12px;position:absolute;left:20px;top:60px;font-style: initial; min-width:200px"
              >
                已有
                <i style="color:red;font-size:16px;">{{item.loanNum || 0}}</i> 户企业获贷
              </i>
            </div>
            <el-button type="primary" @click="(SourceType==null?noShow(item.id):show(item.id))">立即申请</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { listToNotToken, detail } from "@/api/index";
export default {
  data() {
    return {
      fullHeight: document.documentElement.clientHeight,
      productList: [],
      SourceType: "",
      id: "",
      queryID: ""
    };
  },
  computed: {
    getSourceType: function() {
      return this.$store.getters.sourceType;
    }
  },
  watch: {
    fullHeight(val) {
      //监控浏览器高度变化
      if (!this.timer) {
        this.fullHeight = val;
        this.timer = true;
        let that = this;
        setTimeout(function() {
          that.timer = false;
        }, 400);
      }
    },
    $route(n, o) {
      if (n.fullPath !== o.fullPath) {
        //监听路由参数是否变化
        // location.reload()  //强制刷新页面
        this.$router.go(0);
      }
    }
  },

  created() {
    this.id = this.$route.query.id;
    this.SourceType = this.getSourceType;
    this.getList();
  },
  mounted() {
    this.get_bodyHeight();
  },
  methods: {
    show(id) {
      if (this.SourceType == 1) {
        this.$router.push({
          path: "/xyd/product_list_details",
          query: {
            id: id
          }
        });
      } else {
        this.$message.error("权限不足");
      }
    },
    noShow(id) {
      if (this.SourceType == null) {
        this.$router.push({
          path: "/xyd/product_list_details",
          query: {
            id: id
          }
        });
      }
    },
    get_bodyHeight() {
      //动态获取浏览器高度
      const that = this;
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          that.fullHeight = window.fullHeight;
        })();
      };
    },
    getList() {
      let params = {
        id: this.id,
        status: 2
      };
      //
      listToNotToken(this.sendParam(params))
        .then(res => {
          console.log(params, "parmss");

          res = this.paramDecrypt(res);
          console.log(res, "res");
          if (res.code == 200) {
            this.productList = res.data;
          }
        })
        .catch(err => {});
    }
  }
};
</script>
<style lang="less" scoped>
.success {
  background-color: #fff;
  .headImgs {
    img {
      width: 100%;
      height: 200px;
    }
  }
  .productList {
    width: 100%;
    padding-bottom: 25px;
    .list {
      margin: 35px auto;
      padding-bottom: 10px;
      width: 1180px;
      height: 110px;
      background: #ffffff;
      border: 1px solid #d3d5dc;
      border-radius: 6px;
      // padding: 30px 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      .bankName {
        flex: 1;
        display: flex;
        // justify-content: space-between;
        box-sizing: border-box;
        margin-left: 53px;
        text-align: center;
        .name {
          margin-left: 15px;
          display: flex;
          justify-content: space-around;
          flex-direction: row;
          align-items: center;
          img {
            width: 60px;
          }
          span {
            margin-left: 5px;
            font-size: 22px;
            font-family: Alibaba PuHuiTi;
            font-weight: 500;
            color: #2a2a2a;
          }
        }
      }
    }
    .details {
      flex: 1;
      display: flex;
      justify-content: space-between;
      .type {
        display: flex;
        align-items: center;
        justify-content: space-between;
        div {
          align-items: center;
          width: 140px;
          display: flex;
          flex-direction: column;
          font-size: 16px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #595858;
          span {
            font-size: 26px;
            font-family: Alibaba PuHuiTi;
            font-weight: bold;
            color: #b90c1c;
          }
        }
      }
    }
  }
}
</style>